import template from './form.html';
import { FormActions } from 'core/services/form';
import comisionesI18N from 'i18n/comisiones/es.json';
import commonI18N from 'i18n/common/es.json';
import { formatErrorMessage } from 'core/util';


export let ComisionFormComponent = {
  templateUrl: template,
  selector: 'comisionForm',
  bindings: {
    view: '<',
    translations: '='
  },
  controller: FormController,
  controllerAs: 'vm'
};

export const translationKeys = Object.keys(comisionesI18N).concat(Object.keys(commonI18N));


FormController.$inject = [
  '$state', '$ngRedux', 'ngNotify', '$stateParams', 'Filter', 'BasicFactory', '$timeout'
];

function FormController($state, $ngRedux, ngNotify, $stateParams, Filter, BasicFactory, $timeout) {
  this.handleStatus = handleStatus.bind(this);
  this.mapStateToThis = mapStateToThis.bind(this);
  this.doSubmit = doSubmit.bind(this);
  this.loadEmpleados = loadEmpleados.bind(this);
  this.loadServicios = loadServicios.bind(this);
  this.renderEmpleado = renderEmpleado.bind(this);
  this.newDetalle = newDetalle.bind(this);
  this.deleteDetalle = deleteDetalle.bind(this);
  let unsubscribe;


  this.$onDestroy = () => {
    this.form();
    unsubscribe();
  };

  this.$onInit = () => {
    unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);

    if ($stateParams.uid) {
      this.title = this.view ? this.translations['Ver comisión'] : this.translations['Editar comisión'];
      this.formEdit('comisiones', $stateParams.uid);
      this.isEdit = true;
    } else {
      this.title = this.translations['Nueva comisión'];
      this.isEdit = false;
      this.form();
    }
  };


  function mapStateToThis(state) {
    this.handleStatus(state);
    this.submitted = state.form.flags ? state.form.flags.submitted : false;
    this.model = state.form.model;

    if (state.form.model && state.form.model.detalles) {
      for (let i = 0; i < state.form.model.detalles.length; i++) {
        this.especialistasFilter[state.form.model.detalles[i].empleado.id] = true;
      }
    }

    if (this.model && !this.model.id && !this.model.detalles) {
      this.model.detalles = [];
    }

    return {
      form: state.form
    };
  }

  /**
   * Función que se encarga de mostrar mensajes de error/exito en base al estado actual
   *
   * @param {object} state
   */
  function handleStatus(state) {
    if (state.form.notFound) {
      const msg = `${this.translations['No existe el elemento con ID']} ${$stateParams.uid}`;
      ngNotify.set(msg, 'warn');
      $timeout(() => $state.go('home.comisiones.list'));
      return;
    }

    if (state.form.error) {
      ngNotify.set(formatErrorMessage(state.form.error.message), { type: 'error', html: true });
    }

    if (state.form.created) {
      ngNotify.set(this.translations['Datos guardados correctamente'], 'success');
      $state.go('home.comisiones.list');
    }
  }

  function doSubmit() {
    let data = Object.assign({}, this.model);

    data.servicio = {id: data.servicio.id};
    data.detalles = data.detalles.map((comision)=>{
      let {
        id,
        monto,
        descuento,
        activo,
        empleado: {id:empleadoId}
      } = comision;

      return {
        id,
        monto,
        descuento,
        activo,
        empleado: {id:empleadoId}
      };
    });

    this.save('comisiones', data);
  }

  /**
   * Se encarga de traer el backend la lista de empleados a mostrar.
   *
   * @param {string} query
   */
  function loadEmpleados(query) {
    let filter = Filter.path('activo').eq(true);

    if (query) {
      filter = filter.and(Filter.path('nombre').like(query)
        .or(Filter.path('apellido').like(query))
        .or(Filter.path('numeroDocumento').like(query)));
    }

    BasicFactory.setup('empleados');
    return filter ? BasicFactory.all({ filter: JSON.stringify(filter) }) : BasicFactory.all();
  }

  this.filterEspecialista = filterEspecialista.bind(this);

  function filterEspecialista(especialista) {

    if (this.especialistasFilter[especialista.id]) {
      return false;
    } else {
      return true;
    }

  }

  this.especialistasFilter = {};

  this.selectEmpleado = selectEmpleado.bind(this);

  function selectEmpleado(empleado) {
    this.especialistasFilter[empleado.id] = true;
  }


  function renderEmpleado(empleado) {
    return `${empleado.nombre} ${empleado.apellido}`;
  }

  /**
   * Se encarga de traer el backend la lista de servicios a mostrar.
   *
   * @param {string} query
   */
  function loadServicios(query) {
    let filter = Filter.path('categoria.clase.value').eq('Servicio')
      .or(Filter.path('categoria.clase.value').eq('Producto'));

    if (query) {
      filter = filter.and(Filter.path('nombre').like(query));
    }

    filter = filter.and(Filter.path('comision.id').isNull());
    filter = filter.and(Filter.path('categoria.conComision').notEq(true));

    BasicFactory.setup('productos');
    return BasicFactory.all({ filter: JSON.stringify(filter) });
  }

  function newDetalle() {
    this.model.detalles.push({ monto: 0 });
  }

  function deleteDetalle(detalle) {
    if (detalle.empleado) this.especialistasFilter[detalle.empleado.id] = false;
    _.remove(this.model.detalles, detalle);
  }
}



// WEBPACK FOOTER //
// ./src/components/comisiones/form/form.component.js